import axios from 'axios';

export default class EmpleadosServicio {
    URL_SERVIDOR_LOGIN = process.env.VUE_APP_API_URL + "/administracion/beta/Admin/";
    URL_SERVIDOR = process.env.VUE_APP_API_URL +  "/administracion/beta/empleados/";
    URL_INFOMAP = process.env.VUE_APP_API_URL +  "/administracion/beta/InfoMap/";
    datos = [];

    // Removed class-level request tracking variables

    async saveInfo(empleados) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "save", empleados);
            return response;
        } catch (error) {
            console.error("Error al guardar información del empleado:", error);
            throw error;
        }
    }
    
    async todos() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "todos");
            return response;
        } catch (error) {
            console.error("Error al obtener todos los empleados:", error);
            throw error;
        }
    }
    
    async getAll() {
        try {
            const response = await axios.get(this.URL_INFOMAP + "todos");
            return response;
        } catch (error) {
            console.error("Error al obtener toda la información del mapa:", error);
            throw error;
        }
    }
    
    async getEmpId(empId) {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "empId/" + empId);
            return response;
        } catch (error) {
            console.error(`Error al obtener empleado con ID ${empId}:`, error);
            throw error;
        }
    }
    
    async getPuesto(puesto) {
        try {
            const response = await axios.get(this.URL_INFOMAP + "reporte/" + puesto);
            return response;
        } catch (error) {
            console.error(`Error al obtener puesto ${puesto}:`, error);
            throw error;
        }
    }
    
    async save(empleado) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "save", empleado);
            return response;
        } catch (error) {
            console.error("Error al guardar empleado:", error);
            throw error;
        }
    }
    
    async edit(empleado) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "edit", empleado);
            return response;
        } catch (error) {
            console.error("Error al editar empleado:", error);
            throw error;
        }
    }
    
    async upload(file) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "img/upload", file);
            return response;
        } catch (error) {
            console.error("Error al subir imagen:", error);
            throw error;
        }
    }
    
    async login(us, pass) {
        try {
            const loginUrl = this.URL_SERVIDOR_LOGIN + "login/" + us + '/' + pass;
            const response = await axios.get(loginUrl);
            return response;
        } catch (error) {
            console.error("Error al iniciar sesión:", error);
            throw error;
        }
    }
    
    async findTienda(tienda) {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "tienda/" + tienda);
            return response;
        } catch (error) {
            console.error(`Error al buscar tienda ${tienda}:`, error);
            throw error;
        }
    }
    
    async getAllProveedores() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "proveedores");
            return response;
        } catch (error) {
            console.error("Error al obtener todos los proveedores:", error);
            throw error;
        }
    }
    
    async getAllTiendas() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "tiendas");
            return response;
        } catch (error) {
            console.error("Error al obtener todas las tiendas:", error);
            throw error;
        }
    }
    
    async getTabulador() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "tabulador");
            return response;
        } catch (error) {
            console.error("Error al obtener tabulador:", error);
            throw error;
        }
    }
    
    async getEsquemaFiltrar(tipo) {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "esquemas/" + tipo);
            return response;
        } catch (error) {
            console.error(`Error al filtrar esquema por tipo ${tipo}:`, error);
            throw error;
        }
    }
    
    async getCpFiltrar(cp) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "cp", cp);
            return response;
        } catch (error) {
            console.error(`Error al filtrar por código postal ${cp}:`, error);
            throw error;
        }
    }
    
    async getEstados() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "estados");
            return response;
        } catch (error) {
            console.error("Error al obtener estados:", error);
            throw error;
        }
    }
    
    async getBancos(numeroClaveBanco) {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "bancos/" + numeroClaveBanco);
            return response;
        } catch (error) {
            console.error(`Error al obtener banco con clave ${numeroClaveBanco}:`, error);
            throw error;
        }
    }
    
    async getNum(nomEmp) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "count", nomEmp);
            return response;
        } catch (error) {
            console.error("Error al obtener conteo de empleados:", error);
            throw error;
        }
    }
    
    async saveEmpTiendas(empleadosTiendas) {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "empleadosTiendas", empleadosTiendas);
            return response;
        } catch (error) {
            console.error("Error al guardar relación empleados-tiendas:", error);
            throw error;
        }
    }
    
    async getAreas() {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "areas");
            return response;
        } catch (error) {
            console.error("Error al obtener áreas:", error);
            throw error;
        }
    }
    
    async getPuestos() {
        try {
            const response = await axios.post(this.URL_SERVIDOR + "puestos");
            return response;
        } catch (error) {
            console.error("Error al obtener puestos:", error);
            throw error;
        }
    }
    
    async getDepartamentos() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "departamentos");
            return response;
        } catch (error) {
            console.error("Error al obtener departamentos:", error);
            throw error;
        }
    }
    
    async getMarcas() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "marcas");
            return response;
        } catch (error) {
            console.error("Error al obtener marcas:", error);
            throw error;
        }
    }
    
    async getSubMarcas() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "submarcas");
            return response;
        } catch (error) {
            console.error("Error al obtener submarcas:", error);
            throw error;
        }
    }
    
    async getReporte() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "reporte");
            return response;
        } catch (error) {
            console.error("Error al obtener reporte:", error);
            throw error;
        }
    }
    
    async getViewEmpleados() {
        try {
            const response = await axios.get(this.URL_SERVIDOR + "empleadosActivos");
            return response;
        } catch (error) {
            console.error("Error al obtener vista de empleados activos:", error);
            throw error;
        }
    }

    // getViewEmpleados(page = 0, size = 10) {
    //     return axios.get(this.URL_SERVIDOR + "empleadosActivos")
    //             .then(response => {
                    
    //                 return response;
    //             })
    //             .catch(error => {
    //                 
    //                 throw error;
    //             });
    // }

    async getViewEmpleados(filter = 'A', page = 0, size = 10, columnFilters = null) {
        try {
            const headers = {
                'page': page,
                'size': size
            };
            
            // Add timestamp to URL to prevent caching
            const timestamp = new Date().getTime();
            
            // Verificar si filter es un objeto y procesarlo correctamente
            let filterValue = filter;
            if (typeof filter === 'object' && filter !== null) {
                filterValue = 'A'; // Valor por defecto si se pasa un objeto
                
            }
            
            let url = `${this.URL_SERVIDOR}empleadosActivos/${filterValue}?_t=${timestamp}`;
            
            // Agregar parámetros de filtro de columnas si existen
            if (columnFilters && Object.keys(columnFilters).length > 0) {
                const filterParams = new URLSearchParams();
                
                // Convertir el objeto de filtros en parámetros de consulta
                Object.keys(columnFilters).forEach(key => {
                    if (columnFilters[key] && columnFilters[key].trim !== undefined && columnFilters[key].trim() !== '') {
                        filterParams.append(`filter_${key}`, columnFilters[key]);
                    }
                });
                
                // Agregar los parámetros de filtro a la URL si hay alguno
                const filterString = filterParams.toString();
                if (filterString) {
                    url += `&${filterString}`;
                }
            }
            
            const response = await axios.get(url, { headers });
            return response;
        } catch (error) {
            console.error("Error al obtener lista paginada de empleados activos:", error);
            throw error;
        }
    }

    // Nuevo método específico para exportación que devuelve todos los registros
    async getViewEmpleadosExport(filter = 'A', columnFilters = null) {
        try {
            const headers = {
                'page': 0,
                'size': 100000 // Número grande para obtener todos los registros
            };
            
            // Add timestamp to URL to prevent caching
            const timestamp = new Date().getTime();
            
            // Verificar si filter es un objeto y procesarlo correctamente
            let filterValue = filter;
            if (typeof filter === 'object' && filter !== null) {
                filterValue = 'A'; // Valor por defecto si se pasa un objeto
            }
            
            let url = `${this.URL_SERVIDOR}empleadosActivos/${filterValue}?_t=${timestamp}`;
            
            // Agregar parámetros de filtro de columnas si existen
            if (columnFilters && Object.keys(columnFilters).length > 0) {
                const filterParams = new URLSearchParams();
                
                // Convertir el objeto de filtros en parámetros de consulta
                Object.keys(columnFilters).forEach(key => {
                    if (columnFilters[key] && columnFilters[key].trim !== undefined && columnFilters[key].trim() !== '') {
                        filterParams.append(`filter_${key}`, columnFilters[key]);
                    }
                });
                
                // Agregar los parámetros de filtro a la URL si hay alguno
                const filterString = filterParams.toString();
                if (filterString) {
                    url += `&${filterString}`;
                }
            }
            
            const response = await axios.get(url, { headers });
            return response;
        } catch (error) {
            console.error("Error al exportar empleados activos:", error);
            throw error;
        }
    }
}